import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  // add new error refs here
};

export const TIP_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'tip:errors.duplicatedName',
    description: 'tip:errors.duplicatedNameDescription',
  }
};
